import { render, staticRenderFns } from "./ReferenceSearchBox.vue?vue&type=template&id=75aafcb9&scoped=true&"
import script from "./ReferenceSearchBox.vue?vue&type=script&lang=js&"
export * from "./ReferenceSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceSearchBox.vue?vue&type=style&index=0&id=75aafcb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aafcb9",
  null
  
)

export default component.exports